export default [
  {
    value: 'id',
    text: 'ID',
    width: 80,
    type: 'number',
    description: ''
  },
  {
    value: 'name',
    text: 'Имя',
    type: 'string',
    description: ''
  },
  {
    value: 'label',
    text: 'Метка',
    type: 'string',
    description: ''
  },
  {
    value: 'translations',
    text: 'Языки',
    width: 160,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'updatedAt',
    text: 'Обновлено',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Сортировка',
    value: 'sortOrder',
    width: 120,
    type: 'string',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
